export default {
  state: {
    currentRoute: null,
    previousRoute: null
  }
};